// SPDX-License-Identifier: AGPL-3.0-or-later

import {action, makeObservable, observable} from 'mobx';

class TypingChannelFocus {
	enabled = false;

	constructor() {
		makeObservable(this, {enabled: observable, handleRollout: action});
	}

	handleRollout(data: unknown): void {
		this.enabled = (data as {typing_channel_focus?: unknown} | null | undefined)?.typing_channel_focus === true;
	}
}

export default new TypingChannelFocus();
